import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import type { CustomerSlice, CustomerStateType } from './types';

const initialState: CustomerSlice = {
  customerFormShown: false,
  customer: {
    name: null,
    surname: null,
    patronymic: null,
    passportNumber: null,
    nationalityId: 225,
    address: null,
    gender: null,
    birthday: null,
    email: null,
    phone: null,
    docType: 'internal_passport',
  },
};

export const name = 'customer';

const customerSlice = createSlice({
  name,
  initialState,
  reducers: {
    saveCustomer(state, action: PayloadAction<CustomerStateType>) {
      state.customer = action.payload;
      return state;
    },
    setCustomerFormShown(state, action: PayloadAction<boolean>) {
      state.customerFormShown = action.payload;
      return state;
    },
  },
});

export const { saveCustomer, setCustomerFormShown } = customerSlice.actions;

export default customerSlice.reducer;
